import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { autoTestConst, ITests } from '..';

export const getAutoTest = () => async () => {
  const { data } = await $apiV2.get(`/auto-test/view`);

  return { tests: data?.data };
};

export const useAutoTest = () => {
  const { data, ...args } = useQuery<{ tests: ITests[] }>({
    queryKey: [autoTestConst.queryKeys.TOPIC_AUTO_TESTS],
    queryFn: getAutoTest(),
    refetchOnMount: true
  });

  return { ...data, ...args };
};
